<template>
  <div id="feedback">
    <div class="wrap">
      <popups text="问题反馈" @onOff="$emit('onOff', 'feedback')" @confirm="confirm" @changeAnonymous="changeAnonymous" :isAnonymousActive="isAnonymous" :isSubmitQuestion="isSubmitQuestion">
        <div class="content">
          <div class="question-title">
            <input type="text" v-click-outside="closeMoreQuestion" placeholder="问题标题（必填）" v-model.trim="questionTitle" @focus="moreQuestion">
            <div class="list-wrap" v-show="isQuestionList && searchResultList.length !== 0">
              <div class="search-list">
                <div class="search-item">你的提问可能已被解答</div>
                <div class="search-item" v-for="question in searchResultList" :key="question.id" @click="selectQuestion(question.id)">{{ question.topic }}</div>
              </div>
            </div>
          </div>
          <div class="question-type-wrap">
            <div class="question-type" v-click-outside="closeSelect" :class="[typeClass, typeName === '' ? 'show-prompt' : '']" @click="select">{{ typeName === '' ? '选择功能模块' : typeName }}</div>
            <div class="type-list" v-if="showTypeList">
              <div class="type-item"
                   v-for="(type, index) in questionTypeList"
                   :key="type.id"
                   :class="[hoverType === type.id ? type.bgActiveClass : type.bgClass]"
                   @click="selectType(type, index)" @mouseover="hoverQuestionType(type.id)">
                <div class="type-text">{{ type.name }}</div>
              </div>
            </div>
          </div>
          <div class="question-content">
            <textarea placeholder="问题描述（选填）" v-model.trim="questionContent" @paste="pastePicture"></textarea>
            <div class="upload" @click="openPictureCard">上传图片/视频</div>
            <span class="picture-count" v-show="getPictureCount !== 0">共{{ getPictureCount }}个</span>
            <picture-card :fileList="fileList" v-show="isPictureCard" :isFeedback="isFeedback" @deleteFile="deleteFile" @inputChange="inputChange"></picture-card>
          </div>
        </div>
      </popups>
    </div>
  </div>
</template>

<script>
import popups from '../popups/popups'
import pictureCard from '../picture-card/picture-card'
import {formatFileMixin, fetchUploadFileMixin} from '../../mixins/format-file'
import {mapGetters, mapActions} from 'vuex'
import clickOutside from '../../directives/click-outside/index'

export default {
  name: 'feedback',
  mixins: [formatFileMixin, fetchUploadFileMixin],
  components: {
    popups,
    pictureCard
  },
  props: {
    label: Number,
    questionId: Number,
    editQuiz: Boolean,
    props_questionTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isFeedback: true,
      name: 'feedback',
      isTitleFocus: false,
      MAX_FILE_LEN: 12,
      searchResultList: [],
      questionTitle: this.props_questionTitle,
      questionContent: '',
      newQuestionId: null,
      isAnonymous: true,
      isQuestionList: false,
      questionTypeList: [
        {id: 1, name: '任务', bgClass: 'icon-task', bgActiveClass: 'icon-task-active', typeClass: 'task-type', selected: false},
        {id: 13, name: '项目', bgClass: 'icon-project', bgActiveClass: 'icon-project-active', typeClass: 'project-type', selected: false},
        {id: 4, name: '绩效', bgClass: 'icon-performance', bgActiveClass: 'icon-performance-active', typeClass: 'performance-type', selected: false},
        {id: 2, name: 'CRM', bgClass: 'icon-crm', bgActiveClass: 'icon-crm-active', typeClass: 'crm-type', selected: false},
        {id: 3, name: '进销存', bgClass: 'icon-invoicing', bgActiveClass: 'icon-invoicing-active', typeClass: 'invoicing-type', selected: false},
        {id: 5, name: '审批', bgClass: 'icon-approval', bgActiveClass: 'icon-approval-active', typeClass: 'approval-type', selected: false},
        {id: 6, name: '考勤', bgClass: 'icon-attendance', bgActiveClass: 'icon-attendance-active', typeClass: 'attendance-type', selected: false},
        {id: 7, name: '通知', bgClass: 'icon-notice', bgActiveClass: 'icon-notice-active', typeClass: 'notice-type', selected: false},
        {id: 8, name: '数据', bgClass: 'icon-data', bgActiveClass: 'icon-data-active', typeClass: 'data-type', selected: false},
        {id: 9, name: '人事', bgClass: 'icon-personnel', bgActiveClass: 'icon-personnel-active', typeClass: 'personnel-type', selected: false},
        {id: 10, name: '薪酬', bgClass: 'icon-salary', bgActiveClass: 'icon-salary-active', typeClass: 'salary-type', selected: false},
        {id: 11, name: '通讯录', bgClass: 'icon-communication', bgActiveClass: 'icon-communication-active', typeClass: 'communication-type', selected: false},
        {id: 12, name: '人脉', bgClass: 'icon-connection', bgActiveClass: 'icon-connection-active', typeClass: 'connection-type', selected: false},
        {id: 0, name: '其他', bgClass: 'icon-other', bgActiveClass: 'icon-other-active', typeClass: 'other-type', selected: false}
      ],
      typeName: '',
      typeClass: '',
      showTypeList: false,
      quizType: -1,
      searchTime: null,
      inputTime: null,
      fileList: [],
      isPictureCard: false,
      titleLength: 0,
      hoverType: -1,
      isSubmitQuestion: false
    }
  },
  directives: {
    clickOutside
  },
  computed: {
    ...mapGetters([
      'getQuestionPage',
      'getPageSize',
      'getQuestionDetail',
      'getLoading'
    ]),
    getPictureCount () {
      return this.fileList.length
    }
  },
  created () {
    if (this.editQuiz) {
      let questionData = this.getQuestionDetail
      this.questionTitle = questionData.topic
      this.questionContent = questionData.description
      this.quizType = questionData.type
      this.isAnonymous = Boolean(questionData.isAnonymous)
      this.hoverType = this.quizType
      this.fileList = this.formatAttachment(questionData.attachments)
      this.questionTypeList.forEach(item => {
        if (item.id === this.quizType) {
          item.selected = true
          this.typeName = item.name
          this.typeClass = item.typeClass
        } else {
          item.selected = false
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'action_getHotQuestionPage',
      'action_addQuestion',
      'action_getUserQuestionPage',
      'action_getQuestionDetails',
      'action_userUpdateQuestion',
      'action_searchQuestionPage',
      'setQuestionDetail',
      'setQuestionPage',
      'setPageCount',
      'setMessageDetail',
      'setAllQuestionCount',
      'setLoading',
      'setDetailLoading'
    ]),
    confirm () {
      if (this.isSubmitQuestion) {
        return
      }
      let self = this
      let params = null
      if (this.questionTitle !== '' && this.quizType !== -1) {
        if (this.name === 'feedback') {
          // 判断标题长度和描述长度是否已经超出限制
          let titleLength = this.questionTitle.length
          if (titleLength > 60) {
            this.$message({
              type: 'warning',
              message: '标题的字数不能超过60',
              showClose: true
            })
            return
          }
          let contentLength = this.questionContent.length
          if (contentLength > 2000) {
            this.$message({
              type: 'warning',
              message: '问题描述不能超过2000',
              showClose: true
            })
            return
          }
          // 添加新提问
          self.isSubmitQuestion = true
          if (!this.editQuiz) {
            if (self.fileList.length !== 0) {
              self.fetchUploadPicture(self.fileList, function () {
                let attachments = self.formatFileArrayToString(self.fileList)
                self.handler_addNewQuiz(self, attachments)
              })
            } else {
              self.handler_addNewQuiz(self, self.fileList)
            }
          } else {
            // 更改现有提问
            if (self.fileList.length !== 0) {
              self.fetchUploadPicture(self.fileList, function () {
                let attachments = self.formatFileArrayToString(self.fileList)
                let isAnonymous = self.isAnonymous ? 1 : 0
                params = {
                  id: self.questionId,
                  topic: self.questionTitle,
                  description: self.questionContent,
                  type: self.quizType,
                  attachments: attachments,
                  isAnonymous: isAnonymous
                }
                self.action_userUpdateQuestion(params).then(res => {
                  self.isSubmitQuestion = false
                  if (res.erpCode === '000') {
                    self.$emit('changeFeedbackShow')
                    self.setDetailLoading(true)
                    self.action_getQuestionDetails({id: self.questionId}).then(res => {
                      self.setDetailLoading(false)
                      if (res.erpCode === '000') {
                        self.setQuestionDetail(res.erpData)
                      } else {
                        self.showMessage(res.erpMsg || '获取问题详情出错')
                      }
                    })
                  }
                })
              })
            } else {
              let isAnonymous = self.isAnonymous ? 1 : 0
              params = {
                id: self.questionId,
                topic: self.questionTitle,
                description: self.questionContent,
                type: self.quizType,
                attachments: self.fileList,
                isAnonymous: isAnonymous
              }
              self.action_userUpdateQuestion(params).then(res => {
                self.isSubmitQuestion = false
                if (res.erpCode === '000') {
                  self.$emit('changeFeedbackShow')
                  self.setDetailLoading(true)
                  self.action_getQuestionDetails({id: self.questionId}).then(res => {
                    self.setDetailLoading(false)
                    if (res.erpCode === '000') {
                      self.setQuestionDetail(res.erpData)
                    } else {
                      self.showMessage(res.erpMsg || '获取问题详情出错')
                    }
                  })
                } else {
                  self.showMessage(res.erpMsg || '更新问题出错')
                }
              })
            }
          }
        }
      } else {
        // 提示用户具体哪些必填项目未填写
        if (this.questionTitle === '') {
          this.$message({
            showClose: true,
            message: '请输入问题标题',
            type: 'warning'
          })
        } else {
          this.$message({
            showClose: true,
            message: '请选择功能模块',
            type: 'warning'
          })
        }
      }
    },
    pastePicture (e) {
      if (this.fileList.length === this.MAX_FILE_LEN) {
        this.$message.warning(`最多上传${this.MAX_FILE_LEN}个图片或视频`)
        return
      }
      /* eslint-disable one-var */
      var clipboardData = e.clipboardData,
        i = 0,
        items, item, types

      if (clipboardData) {
        items = clipboardData.items
        if (!items) {
          return
        }

        item = items[0]
        // 保存在剪贴板中的数据类型
        types = clipboardData.types || []

        for (; i < types.length; i++) {
          if (types[i] === 'Files') {
            item = items[i]
            break
          }
        }
        // 判断是否为图片数据
        if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
          // 读取该图片
          this.imgReader(item)
          this.isPictureCard = true
        }
      }
    },
    imgReader (item) {
      if (this.fileList.length === this.MAX_FILE_LEN) {
        return
      }
      var blobFile = item.getAsFile()
      var picFile = new File([blobFile], 'image.png', {type: 'image/png'}) // 将blob数据 转为file对象

      var reader = new FileReader()
      // 读取文件
      reader.onload = (e) => {
        var src = e.target.result
        this.fileList.push({file: picFile, src: src, isUploaded: false})
      }
      reader.readAsDataURL(blobFile)
    },
    handler_addNewQuiz (self, attachments) {
      let isAnonymous = self.isAnonymous ? 1 : 0
      let params = {
        topic: self.questionTitle,
        description: self.questionContent,
        type: self.quizType,
        isAnonymous: isAnonymous,
        attachments: attachments
      }
      self.action_addQuestion(params).then(res => {
        this.isSubmitQuestion = false
        self.$emit('changeFeedbackShow')
        if (res.erpCode === '000') {
          self.newQuestionId = res.erpData.id
          let userParams = {
            currentPage: 0,
            pageSize: self.getPageSize
          }
          this.$emit('updateQuestionId', self.newQuestionId)
          this.setLoading(true)
          self.action_getUserQuestionPage(userParams).then(res => {
            this.setLoading(false)
            if (res.erpCode === '000') {
              let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / userParams.pageSize) : 1
              self.setQuestionPage(res.erpData.pageItem)
              this.setAllQuestionCount(res.erpData.totalCount)
              self.setPageCount(count)
            } else {
              self.showMessage(res.erpMsg || '获取问题列表出错')
            }
          })
          self.setDetailLoading(true)
          self.$router.push({path: '/help', query: {questionId: self.newQuestionId, questionHash: Math.random()}})
        } else {
          self.showMessage(res.erpMsg || '添加问题出错')
        }
      })
    },
    changeAnonymous (isAnonymousActive) {
      this.isAnonymous = isAnonymousActive
    },
    moreQuestion () {
      this.isTitleFocus = true
      this.isQuestionList = true
    },
    closeMoreQuestion () {
      this.isTitleFocus = false
      this.isQuestionList = false
    },
    hoverQuestionType (typeId) {
      this.hoverType = typeId
    },
    select () {
      if (this.showTypeList) {
        this.hoverType = this.quizType
      }
      this.showTypeList = !this.showTypeList
    },
    closeSelect () {
      this.hoverType = this.quizType
      this.showTypeList = false
    },
    selectType (type, index) {
      this.typeName = type.name
      this.typeClass = type.typeClass
      this.quizType = type.id
      this.showTypeList = false
      this.questionTypeList.forEach((item, n) => {
        if (index !== n) {
          item.selected = false
        } else {
          this.hoverType = this.quizType
          item.selected = true
        }
      })
    },
    selectQuestion (id) {
      this.isQuestionList = false
      this.$emit('selectQuestion', id)
    },
    handler_searchQuiz (val) {
      let params = {
        keyword: val,
        currentPage: 0,
        pageSize: 10
      }
      this.action_searchQuestionPage(params).then(res => {
        if (res.erpCode === '000') {
          this.searchResultList = res.erpData.pageItem
          this.isQuestionList = (this.searchResultList.length !== 0) && this.isTitleFocus
        } else {
          this.showMessage(res.erpMsg || '搜索问题出错')
        }
      })
    },
    openPictureCard () {
      this.isPictureCard = !this.isPictureCard
    },
    deleteFile (index) {
      if (this.fileList[index] && this.fileList[index].localUrl) {
        URL.revokeObjectURL(this.fileList[index].localUrl)
      }
      this.fileList.splice(index, 1)
    },
    inputChange (event) {
      var length = event.target.files.length
      if (this.fileList.length + length > this.MAX_FILE_LEN) {
        this.$message.warning(`最多上传${this.MAX_FILE_LEN}个图片或视频`)
        return
      }
      var fileOnLoadPromiseArr = []
      for (var i = 0; i < length; i++) {
        let file = event.target.files[i]
        if (file === undefined) {
          break
        }
        if (!this.isAcceptMediaFile(file)) {
          this.$message({
            showClose: true,
            message: '仅支持上传 JPG、jpeg、gif、PNG、MP4 或 MOV 格式!',
            type: 'error'
          })
          return
        }
        if (this.isVideoOverLimit(file)) {
          this.$message({
            showClose: true,
            message: '视频大小不能超过200MB',
            type: 'error'
          })
          return
        }
        fileOnLoadPromiseArr.push(
          new Promise(resolve => {
            if (this.isVideoFile(file)) {
              this.buildLocalVideoFile(file).then(resolve)
              return
            }
            var fr = new FileReader()
            fr.onload = function (e) {
              var src = e.target.result
              resolve({src, file, isVideo: false})
            }
            fr.readAsDataURL(file)
          }))
      }
      Promise.all(fileOnLoadPromiseArr)
        .then(results => {
          results.forEach((res) => {
            this.fileList.push(Object.assign({}, res, {isUploaded: false}))
          })
        })
        .then(() => {
          event.target.value = ''
        })
    }
  },
  watch: {
    questionTitle (val) {
      clearTimeout(this.searchTime)
      clearTimeout(this.inputTime)
      this.searchTime = setTimeout(() => {
        if (val !== '') {
          this.handler_searchQuiz(val)
        } else {
          this.isQuestionList = false
          this.searchResultList = []
        }
      }, 200)
      this.inputTime = setTimeout(() => {
        let titleLength = val.length
        if (titleLength > 60) {
          this.$message({
            type: 'warning',
            message: '标题不能超过60字',
            showClose: true
          })
        }
      }, 1000)
    },
    questionContent (val) {
      clearTimeout(this.inputTime)
      this.inputTime = setTimeout(() => {
        let contentLength = val.length
        if (contentLength > 2000) {
          this.$message({
            type: 'warning',
            message: '内容不能超过2000字',
            showClose: true
          })
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
  ::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
  ::-webkit-scrollbar {
    width: 1px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #333;
  }

  #feedback {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .wrap {
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    top: 41%;
    transform: translate(-50%, -50%);
    width: 580px;
    height: 574px;
    padding: 34px 40px 34px 41px;
    background: #fff;
    z-index: 999;
  }

  .content {
    width: 500px;
    margin-top: 41px;
  }

  .question-title {
    position: relative;
    margin-bottom: 20px;
  }

  .question-title input {
    box-sizing: border-box;
    width: 500px;
    height: 50px;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    padding: 0 12px;
    line-height: 48px;
  }

  .question-type-wrap {
    position: relative;
    margin-bottom: 20px;
  }
  .question-type {
    box-sizing: border-box;
    width: 500px;
    height: 50px;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    padding: 0 12px 0 40px;
    color: #333;
    line-height: 48px;
    cursor: pointer;
  }
  .show-prompt {
    color: #ccc;
    padding-left:  12px;
  }
  .other-type {
    background: url("../../icons/image/question-type/other.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .task-type {
    background: url("../../icons/image/question-type/task.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .project-type {
    background: url("../../icons/image/question-type/project.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .crm-type {
    background: url("../../icons/image/question-type/CRM.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .invoicing-type {
    background: url("../../icons/image/question-type/invoicing.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .performance-type {
    background: url("../../icons/image/question-type/performance.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .approval-type {
    background: url("../../icons/image/question-type/approval.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .attendance-type {
    background: url("../../icons/image/question-type/attendance.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .notice-type {
    background: url("../../icons/image/question-type/notice.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .data-type {
    background: url("../../icons/image/question-type/data.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .personnel-type {
    background: url("../../icons/image/question-type/personnel.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .salary-type {
    background: url("../../icons/image/question-type/salary.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .communication-type {
    background: url("../../icons/image/question-type/address-book.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .connection-type {
    background: url("../../icons/image/question-type/connection.svg") no-repeat 15px center;
    background-size: 20px 20px;
  }
  .type-list {
    box-sizing: border-box;
    display: flex;
    align-content: space-between;
    flex-wrap: wrap;
    position: absolute;
    top: 52px;
    width: 500px;
    height: 275px;
    padding: 23px 0 28px;
    border: 1px solid #4A90E2;
    border-radius: 4px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(74, 144, 226, 0.58);
    z-index: 99;
  }
  .type-item {
    box-sizing: border-box;
    width: 37px;
    height: 56px;
    margin: 0 23px;
    color: #ccc;
    text-align: center;
    cursor: pointer;
  }
  .type-text {
    margin-top: 39px;
    font-size: 12px;
    text-align: center;
    letter-spacing: -0.07px;
  }
  .icon-task {
    background: url("../../icons/image/question-type/task-gray.svg") no-repeat center top;
  }
  .icon-task-active {
    color: #333;
    background: url("../../icons/image/question-type/task.svg") no-repeat center top;
  }
  .icon-project {
    background: url("../../icons/image/question-type/project-gray.svg") no-repeat center top;
  }
  .icon-project-active {
    color: #333;
    background: url("../../icons/image/question-type/project.svg") no-repeat center top;
  }
  .icon-crm {
    background: url("../../icons/image/question-type/CRM灰.svg") no-repeat center top;
  }
  .icon-crm-active {
    color: #333;
    background: url("../../icons/image/question-type/CRM.svg") no-repeat center top;
  }
  .icon-invoicing {
    background: url("../../icons/image/question-type/invoicing-gray.svg") no-repeat center top;
  }
  .icon-invoicing-active {
    color: #333;
    background: url("../../icons/image/question-type/invoicing.svg") no-repeat center top;
  }
  .icon-performance {
    background: url("../../icons/image/question-type/performance-gray.svg") no-repeat center top;
  }
  .icon-performance-active {
    color: #333;
    background: url("../../icons/image/question-type/performance.svg") no-repeat center top;
  }
  .icon-approval {
    background: url("../../icons/image/question-type/approval-gray.svg") no-repeat center top;
  }
  .icon-approval-active {
    color: #333;
    background: url("../../icons/image/question-type/approval.svg") no-repeat center top;
  }
  .icon-attendance {
    background: url("../../icons/image/question-type/attendance-gray.svg") no-repeat center top;
  }
  .icon-attendance-active {
    color: #333;
    background: url("../../icons/image/question-type/attendance.svg") no-repeat center top;
  }
  .icon-notice {
     background: url("../../icons/image/question-type/notice-gray.svg") no-repeat center top;
   }
  .icon-notice-active {
    color: #333;
    background: url("../../icons/image/question-type/notice.svg") no-repeat center top;
  }
  .icon-data {
    background: url("../../icons/image/question-type/data-gray.svg") no-repeat center top;
  }
  .icon-data-active {
    color: #333;
    background: url("../../icons/image/question-type/data.svg") no-repeat center top;
  }
  .icon-personnel {
    background: url("../../icons/image/question-type/personnel-gray.svg") no-repeat center top;
  }
  .icon-personnel-active {
    color: #333;
    background: url("../../icons/image/question-type/personnel.svg") no-repeat center top;
  }
  .icon-salary {
     background: url("../../icons/image/question-type/salary-gray.svg") no-repeat center top;
   }
  .icon-salary-active {
    color: #333;
    background: url("../../icons/image/question-type/salary.svg") no-repeat center top;
  }
  .icon-communication {
    background: url("../../icons/image/question-type/address-book-gray.svg") no-repeat center top;
  }
  .icon-communication-active {
    color: #333;
    background: url("../../icons/image/question-type/address-book.svg") no-repeat center top;
  }
  .icon-connection {
    background: url("../../icons/image/question-type/connection-gray.svg") no-repeat center top;
  }
  .icon-connection-active {
    color: #333;
    background: url("../../icons/image/question-type/connection.svg") no-repeat center top;
  }
  .icon-other {
    background: url("../../icons/image/question-type/other-gray.svg") no-repeat center top;
  }
  .icon-other-active {
    color: #333;
    background: url("../../icons/image/question-type/other.svg") no-repeat center top;
  }

  .question-content {
    position: relative;
    height: 222px;
    margin-bottom: 50px;
  }

  .question-content textarea {
    box-sizing: border-box;
    width: 500px;
    height: 222px;
    padding: 15px 12px 0;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    resize: none;
  }

  .upload {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: absolute;
    left: 13px;
    bottom: 10px;
    width: auto;
    height: 30px;
    padding: 0 10px 0 36px;
    font-size: 14px;
    color: #777777;
    line-height: normal;
    border-radius: 4px;
    letter-spacing: -0.34px;
    white-space: nowrap;
    background: #EFEFEF url("../../icons/upload-image.svg") no-repeat 10px center;
    cursor: pointer;
  }
  .picture-count {
    position: absolute;
    left: 154px;
    bottom: 10px;
    height: 26px;
    padding: 0 5px;
    border-radius: 3px;
    color: #030303;
    line-height: 26px;
    background: #fff;
  }

  .list-wrap {
    position: absolute;
    top: 52px;
    left: -1px;
    overflow: hidden;
    z-index: 99;
  }

  .search-list {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    overflow-y: hidden;
    overflow-x: hidden;
    width: 502px;
    max-height: 274px;
    padding: 0 14px;
    border-radius: 3px;
    margin-bottom: 44px;
    border: 1px solid #4A90E2;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(74, 144, 226, 0.58);
  }
  .search-list:hover {
    overflow-y: scroll;
  }

  .search-item {
    width: 472px;
    height: 44px;
    border-bottom: 1px solid #DBDBDB;
    margin-bottom: 1px;
    font-size: 15px;
    color: #333333;
    line-height: 44px;
    letter-spacing: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .search-item:nth-child(1) {
    height: 34px;
    color: #777777;
    line-height: 34px;
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback/feedback.vue